module.exports = __webpack_public_path__ + "img/DE05890.d9dded5a.png";